import React from 'react'
import PortfolioItem from './portfolioItem';

const PortfolioList = (props) => {
	const renderPortfolioListItems = props.items.map(((i, index) => {
		return (
			<PortfolioItem key={index} item = {i} />
		)
	}))
	return (
		<div className="PortfolioList">
			{renderPortfolioListItems}
		</div>
	)
}

export default PortfolioList



// WEBPACK FOOTER //
// ./src/portfolioList.js